module.exports = __webpack_public_path__ + "img/ic_download.5c54d456.svg";